import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import Joi from 'joi'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  hiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  billingCycles: Joi.object({
    monthly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    quarterly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    semiannual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  copaymentTypes: Joi.any().allow(null),
  insuranceTypes: Joi.object({
    family: Joi.object({
      id: Joi.string().required(),
      textMe: Joi.string().required(),
      textNotMe: Joi.string().required(),
      textOptionalCoverageSelectInfo: Joi.string().required(),
      disabled: Joi.boolean().required(),
      default: Joi.boolean().required()
    }).required(),
    mortgage: Joi.object({
      id: Joi.string().required(),
      textMe: Joi.string().required(),
      textNotMe: Joi.string().required(),
      textOptionalCoverageSelectInfo: Joi.string().required(),
      disabled: Joi.boolean().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  capitalOptions: Joi.array()
    .items(
      Joi.object({
        age: Joi.number().integer().min(0).required(),
        older: Joi.boolean().required(),
        equals: Joi.boolean().required(),
        min: Joi.number().integer().min(0).required(),
        max: Joi.number().integer().greater(Joi.ref('min')).required()
      })
    )
    .min(2)
    .required(),
  tags: Joi.object({
    capitalToInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    capitalToInsuredContactAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required(),
      // todo - linkText ??
      linkText: Joi.string().required()
    }).required(),
    professionLowRiskAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    professionHighRiskAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    activityHighRiskAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    capitalToInsuredContactAlertMediator: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required(),
      phoneText: Joi.string().required(),
      emailText: Joi.string().required()
    }),
    professionHighRiskAlertMediator: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }),
    activityHighRiskAlertMediator: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }),
    capitalAlertAmountMediator: Joi.string(),
    capitalAlertMediatorContactPhone: Joi.string(),
    capitalAlertMediatorContactEmail: Joi.string(),
    alertRiskProfessionMediator: Joi.string(),
    alertRiskActivityMediator: Joi.string(),
    holderAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    mortgageLoanAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    heirsPolicyBeneficiariesAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    myPolicyBeneficiariesAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required()
  })
    .required()
    .error((errors) => {
      const text = `DXP Life branch configuration - ${errors
        .map((e) => `"${e.local.label}" is required`)
        .join()}`
      return new ConsoleError({ message: text })
    })
    .unknown(true)
})
